var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isLoading && _vm.currentServiceArea
        ? _c("display-categories", {
            attrs: {
              "current-service-area": _vm.currentServiceArea,
              "current-service-line": _vm.currentServiceLine,
              "service-areas": _vm.serviceTaxonomy,
              "platform-category": _vm.platformCategory,
              "platform-category-name": _vm.platformCategoryName,
              showDropdownForActionBrowse: _vm.showDropdownForActionBrowse
            },
            on: {
              clickSARoute: _vm.clickSARoute,
              clickSLRoute: _vm.clickSLRoute
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.serviceLines && _vm.serviceTaxonomy.length != 1
        ? _c("display-sub-categories", {
            attrs: {
              "service-lines": _vm.serviceLines,
              "current-service-line": _vm.currentServiceLine,
              "platform-category": _vm.platformCategory
            },
            on: { clickSLRoute: _vm.clickSLRoute }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.currentServiceLine
        ? _c("display-services", {
            attrs: {
              services: _vm.currentServiceLine.services,
              "platform-category": _vm.platformCategory,
              "service-id": _vm.serviceId
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3348d3a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3348d3a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-browser/BrowseServiceTaxonomyService.vue
// module id = null
// module chunks = 